const currentYear = new Date().getFullYear();

function replaceYearToCurrent(date: string): string {
	return currentYear.toString() + date.slice(4);
}

export default replaceYearToCurrent;
